module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0131.jpg?v=f2e5f1bf";